import { isEn, locale } from "./locale";
import { type MsgKey, t } from "./messages";

const ATTRS = [
  ["i18n", null],
  ["i18nAria", "aria-label"],
  ["i18nPh", "placeholder"],
] as const;

/**
 * Translate the static markup in index.html. It ships in zh-Hant (what
 * crawlers and no-JS readers see); elements opt in with data-i18n (text),
 * data-i18n-aria (aria-label) or data-i18n-ph (placeholder).
 */
export function applyStaticText(root: ParentNode = document): void {
  document.documentElement.lang = locale;
  document.title = t("doc.title");
  if (!isEn) return;
  for (const [data, attr] of ATTRS) {
    const sel = `[data-${data.replace(/[A-Z]/g, (c) => "-" + c.toLowerCase())}]`;
    for (const el of root.querySelectorAll<HTMLElement>(sel)) {
      const key = el.dataset[data] as MsgKey;
      // Keys taking {vars} are filled in by the code that owns the element.
      const text = (t as (k: MsgKey) => string)(key);
      if (attr) el.setAttribute(attr, text);
      else el.textContent = text;
    }
  }
}
